import axios from 'axios';
import { API_URL } from '../../services/apiUrl';
import { participantToken, questionStartedAt, saveParticipantToken } from './storage';

const baseURL = `${API_URL}/quiz`;

const api = axios.create({ baseURL });

export const listQuizzes = async () => (await api.get('/host/quizzes')).data;

export const createSession = async (slug, name) => (await api.post('/host/sessions', { slug, name })).data;

export const listSessions = async () => (await api.get('/host/sessions')).data;

export const joinSession = async (joinCode) => {
    const { data } = await api.post(`/sessions/${joinCode}/join`, {
        participantToken: participantToken(),
    });
    // The server has the final say: it mints a replacement for anything it will
    // not accept, and that is the token the next join must send.
    saveParticipantToken(data.participantToken);
    return { state: data.state, displayName: data.displayName };
};

// The only call here with no `.data`: the server answers 204, having nothing to
// say about a student's own answer that their screen doesn't already show.
export const submitResponse = (joinCode, optionIndex, ord) => {
    const startedAt = questionStartedAt(joinCode, ord);
    return api.post(`/sessions/${joinCode}/respond`, {
        participantToken: participantToken(),
        ord,
        optionIndex,
        ...(startedAt !== null && { clientAnswerMs: Date.now() - startedAt }),
    });
};

export const startSession = async (sessionId) => (await api.post(`/host/sessions/${sessionId}/start`)).data;
export const revealQuestion = async (sessionId) => (await api.post(`/host/sessions/${sessionId}/reveal`)).data;
export const nextQuestion = async (sessionId) => (await api.post(`/host/sessions/${sessionId}/next`)).data;
export const endSession = async (sessionId) => (await api.post(`/host/sessions/${sessionId}/end`)).data;
export const sessionAnalytics = async (sessionId) => (await api.get(`/host/sessions/${sessionId}/analytics`)).data;

// EventSource takes a URL, not an axios instance, so these are built by hand.
export const hostStreamUrl = (sessionId) => `${baseURL}/host/sessions/${sessionId}/stream`;
export const studentStreamUrl = (joinCode) => `${baseURL}/sessions/${joinCode}/stream`;
